import { LoginCrossPlatformAction, LoginCrossPlatformActionResponseSuccess, ValidationErrorResponse } from './login-cross-platform';
import { Error } from '../error';

interface ResponseWithStatus<T> {
	status: number;
	data: T;
}

export const loginCrossPlatformSuccessMock: LoginCrossPlatformAction = async (): Promise<ResponseWithStatus<LoginCrossPlatformActionResponseSuccess>> => {
	const result: LoginCrossPlatformActionResponseSuccess = {
		playerId: 123456,
		redirectUrl: '/login-successful',
	};

	return Promise.resolve({
		status: 200,
		data: result,
	});
};

export const loginCrossPlatformErrorMock: LoginCrossPlatformAction = async (): Promise<ResponseWithStatus<ValidationErrorResponse>> => {
	const result: ValidationErrorResponse = {
		errors: new Map<string, Error[]>([
			['mail', [{ code: 'error', message: 'System error' }]]
		])
	};

	return Promise.resolve({
		status: 500,
		data: result,
	});
};

export const loginCrossPlatformMailMocks: {
	loginCrossPlatformMailSuccess: LoginCrossPlatformAction;
	loginCrossPlatformMailValidationError: LoginCrossPlatformAction;
} = {
	loginCrossPlatformMailSuccess: loginCrossPlatformSuccessMock,
	loginCrossPlatformMailValidationError: loginCrossPlatformErrorMock
};
